/**
* Created by CHENRC2 on 2018-1-10.
*/
<template>
    <div class="wrapper-menu">
        <template v-for="menu in menus">
            <el-submenu :name="menu.frontUrl || menu.resourceCode" v-if="+menu.resourceType === 1 && menu.subResources && menu.subResources.length" :index="menu.resourceCode" :key="menu.resourceCode">
                <template slot="title">
                    <span v-if="menu.resourceUrl && sub">
                        <img v-if="menu.resourceUrl.indexOf('//') > -1" :src="menu.resourceUrl" alt="icon" width="18" height="18">
                        <i v-else-if="menu.resourceUrl.indexOf('icon-') > -1" class="menu-icon" :class="menu.resourceUrl"></i>
                        <i v-else class="menu-icon el-icon-menu"></i>
                    </span>
                    <i v-else-if="sub" class="menu-icon el-icon-menu"></i>
                    <span slot="title" v-if="!collapse" :title="$translate(`lang.${menu.resourceCode}`)">
                        {{ $translate(`lang.${menu.resourceCode}`, { defaultText:menu.resourceName })}}
                    </span>
                </template>
                <sidebar-item :menus="menu.subResources" :sub='false'></sidebar-item>
            </el-submenu>
            <a :href="menu.frontUrl" target="_blank" v-else-if="menu.frontUrl&&menu.frontUrl.indexOf('http')>=0" :key="menu.resourceCode" class="routeLink">
                <el-menu-item   @click="menuClickAction(menu)" :index="menu.resourceCode" :name="menu.frontUrl || menu.resourceCode">
                    <span v-if="menu.resourceUrl && sub">
                        <img v-if="menu.resourceUrl.indexOf('//') > -1" :src="menu.resourceUrl" alt="icon" width="18" height="18">
                        <i v-else-if="menu.resourceUrl.indexOf('icon-') > -1" class="menu-icon" :class="menu.resourceUrl"></i>
                        <i v-else class="menu-icon el-icon-menu"></i>
                    </span>
                    <i v-else-if="sub" class="menu-icon el-icon-menu"></i>
                    <span slot="title" v-if="!collapse" :title="$translate(`lang.${menu.resourceCode}`)">
                        {{ $translate(`lang.${menu.resourceCode}`, { defaultText:menu.resourceName })}}
                    </span>
                </el-menu-item>
            </a>
            <router-link :to="menu.frontUrl" v-else-if="+menu.resourceType === 2 && menu.extendAttr1 !== 'hidden'" :key="menu.resourceCode" class="routeLink">
                <el-menu-item   @click="menuClickAction(menu)" :index="menu.resourceCode" :name="menu.frontUrl || menu.resourceCode">
                    <span v-if="menu.resourceUrl && sub">
                        <img v-if="menu.resourceUrl.indexOf('//') > -1" :src="menu.resourceUrl" alt="icon" width="18" height="18">
                        <i v-else-if="menu.resourceUrl.indexOf('icon-') > -1" class="menu-icon" :class="menu.resourceUrl"></i>
                        <i v-else class="menu-icon el-icon-menu"></i>
                    </span>
                    <i v-else-if="sub" class="menu-icon el-icon-menu"></i>
                    <span slot="title" v-if="!collapse" :title="$translate(`lang.${menu.resourceCode}`)">
                        {{ $translate(`lang.${menu.resourceCode}`, { defaultText:menu.resourceName })}}
                    </span>
                </el-menu-item>
            </router-link>
        </template>
    </div>
</template>
<style lang="less">
.wrapper-menu {
    .el-menu-item {
        height: 46px;
        line-height: 46px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background-color: #242c3e !important;
    }
    .el-menu-item:hover {
        background: #1c2333 !important;
    }
    .menu-icon {
        display: inline-block;
        width: 24px;
        font-size: 16px;
        color: #fff;
        margin-right: 5px;
        margin-left: -5px;
        text-align: center;
    }
    .el-submenu {
        .menu-icon {
            margin-left: -5px;
            color: #fff;
        }
        .el-menu-item {
            height: 38px;
            line-height: 38px;
            background: #242c3e !important;
        }
        .el-menu-item:hover {
            background: #1c2333 !important;
        }
        &.is-active .el-submenu__title {
            background-color: #1c2333 !important;
        }
    }
    /*菜单关闭*/
    .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
        -webkit-transform: rotateZ(-90deg);
        -ms-transform: rotate(-90deg);
        transform: rotateZ(-90deg);
        color: #aaaaaa;
    }
    /*菜单展开*/
    .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
        -webkit-transform: rotateZ(0deg);
        -ms-transform: rotate(0deg);
        transform: rotateZ(0deg);
        color: #ffffff;
    }
    .el-submenu__title {
        height: 46px;
        line-height: 46px;
        background-color: #242c3e !important;
    }
    .el-submenu__title:hover {
        background: #1c2333 !important;
    }
    .icon-sn-home,
    .icon-sn-product,
    .icon-sn-identification,
    .icon-sn-system,
    .icon-sn-log,
    .icon-sn-report,
    .icon-sn-barInfo,
    .icon-sn-barInventory,
    .icon-sn-scanCode,
    .icon-sn-visual,
    .icon-sn-stock {
        position: relative;
    }
    .el-icon-document-copy {
        font-size: 14px;
        margin-top: -4px;
    }
    .styleDisplay() {
        content: "";
        position: absolute;
        height: 16px;
        width: 16px;
        left: 4px;
        top: -8px;
    }
    .icon-sn-home::before {
        .styleDisplay();
        background: url("../../../../assets/home.svg") no-repeat;
    }
    .icon-sn-product::before {
        .styleDisplay();
        background: url("../../../../assets/snproduct.svg") no-repeat;
    }
    .icon-sn-identification::before {
        .styleDisplay();
        background: url("../../../../assets/identification.svg") no-repeat;
    }
    .icon-sn-system::before {
        .styleDisplay();
        background: url("../../../../assets/snsystem.svg") no-repeat;
    }
    .icon-sn-log::before {
        .styleDisplay();
        background: url("../../../../assets/snlog.svg") no-repeat;
    }
    .icon-sn-report::before {
        .styleDisplay();
        background: url("../../../../assets/rep.svg") no-repeat;
    }
    .icon-sn-barInfo::before {
        .styleDisplay();
        background: url("../../../../assets/barInfo.svg") no-repeat;
    }
    .icon-sn-barInventory::before {
        .styleDisplay();
        background: url("../../../../assets/barInventory.svg") no-repeat;
    }
    .icon-sn-scanCode::before {
        .styleDisplay();
        background: url("../../../../assets/scanCode.svg") no-repeat;
    }
    .icon-sn-visual::before {
        .styleDisplay();
        background: url("../../../../assets/visual.svg") no-repeat;
    }
    .icon-sn-stock::before {
        .styleDisplay();
        background: url("../../../../assets/stock.svg") no-repeat;
    }
}
</style>
<script>
import { navigate } from '../core';
import { I18nMixins } from '@/utils/i18n';
import {
    getResourceNameByCode,
    sendInfoToBigData
} from '@/utils/asideMenuAction.js';
import { mapGetters } from 'vuex';
export default {
    name: 'SidebarItem',
    mixins: [I18nMixins],
    props: {
        menus: {
            type: Array,
            default() {
                return [];
            }
        },
        collapse: {
            default() {
                return false;
            }
        },
        sub: {
            type: Boolean,
            default() {
                return true;
            }
        }
    },
    computed: {
        ...mapGetters(['authority'])
    },
    data() {
        return {
            menuchild: [],
            message: 'developer.message'
        };
    },
    methods: {
        menuClickAction(info) {
            getResourceNameByCode(info.resourceCode, this.authority);
            sendInfoToBigData();
        },
        // 菜单导航
        handleMenuSelect(routerLink) {
            navigate(this.$router, routerLink);
        },
        // 判断当前菜单子级是按钮还是空
        computedChildIsButtonOrNull(menu) {
            let hasSubOrNull = true;
            if (menu && menu.subResources && menu.subResources.length > 0) {
                const childIsButton = menu.subResources.filter(m => m.fdType === 'F');
                hasSubOrNull = childIsButton.length > 0;
            }
            return hasSubOrNull;
        }
    }
};
</script>
